import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type NotificationKind = 'success' | 'error' | 'info' | 'warning';

export interface AppNotification {
  /** Increments on every toast so a repeat of the same message still restarts the 5 s timer. */
  id: number;
  type: NotificationKind;
  /** Kept for parity with Angular; the toast only ever displays `message`. */
  header: string;
  message: string;
}

interface NotificationState {
  current: AppNotification | null;
  counter: number;
}

const initialState: NotificationState = { current: null, counter: 0 };

/** One toast slot: a new notification replaces the current one (Angular's single-slot behaviour). */
const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    show(state, action: PayloadAction<Omit<AppNotification, 'id'>>) {
      state.counter += 1;
      state.current = { id: state.counter, ...action.payload };
    },
    hide(state) {
      state.current = null;
    },
  },
});

export const { show: showNotification, hide: hideNotification } = notificationSlice.actions;
export const notificationReducer = notificationSlice.reducer;
